import { render, staticRenderFns } from "./AddAddr.vue?vue&type=template&id=a8ea26f6&scoped=true&"
import script from "./AddAddr.vue?vue&type=script&lang=js&"
export * from "./AddAddr.vue?vue&type=script&lang=js&"
import style0 from "./AddAddr.vue?vue&type=style&index=0&id=a8ea26f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ea26f6",
  null
  
)

export default component.exports